import {Component, Input} from '@angular/core';

/**
 * Simple component to display a label/value pair in a single row
 */
@Component({
    selector: 'detail',
    templateUrl: 'detail.html'
})
export class DetailComponent
{
    @Input() label: string;
    @Input() value: string;
    @Input() isCurrency: boolean;
    
    constructor()
    {
    }
}



// WEBPACK FOOTER //
// ./src/components/detail/detail.ts